import { render, staticRenderFns } from "./BuscaCep.vue?vue&type=template&id=2d0c2ba6&scoped=true"
import script from "./BuscaCep.vue?vue&type=script&lang=js"
export * from "./BuscaCep.vue?vue&type=script&lang=js"
import style0 from "./BuscaCep.vue?vue&type=style&index=0&id=2d0c2ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0c2ba6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
